import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@mui/material';
import { useEditorRef } from 'platejs/react';
import {
    deleteColumn,
    deleteRow,
    deleteTable,
    insertTable,
    insertTableColumn,
    insertTableRow,
} from '@platejs/table';

import { unwrapList } from 'common/components/ContentEditor/utils/editorHelpers';
import {
    IToolbarButtonProps,
    ToolbarButton,
} from 'common/components/ContentEditor/components/EditorToolbar/ToolbarButton';

export const ToolbarTable = ({ ...other }: IToolbarButtonProps) => {
    const { t: translate } = useTranslation();
    const editor = useEditorRef();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <ToolbarButton
                onMouseDown={(event) => {
                    setAnchorEl(event.currentTarget as HTMLElement);
                }}
                {...other}
            />
            <Menu
                keepMounted
                anchorEl={anchorEl}
                id="simple-menu"
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={() => {
                        insertTable(editor, { rowCount: 2, colCount: 2 });
                        unwrapList(editor);
                        handleClose();
                    }}
                >
                    {translate('editor.insertTable')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        deleteTable(editor);
                        handleClose();
                    }}
                >
                    {translate('editor.deleteTable')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        insertTableRow(editor);
                        handleClose();
                    }}
                >
                    {translate('editor.addRow')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        deleteRow(editor);
                        handleClose();
                    }}
                >
                    {translate('editor.deleteRow')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        insertTableColumn(editor);
                        handleClose();
                    }}
                >
                    {translate('editor.addColumn')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        deleteColumn(editor);
                        handleClose();
                    }}
                >
                    {translate('editor.deleteColumn')}
                </MenuItem>
            </Menu>
        </>
    );
};
